import ReactPaginate from "react-paginate";

export default function Pagenation({
    totalCount, 
    perPage, 
    setPage,
    currentPage,
}: {
    totalCount: number, 
    perPage: number, 
    setPage: Function,
    currentPage?: number
}){

    const handlePageClick = (data: { selected: number })=> {
        setPage(data.selected + 1)
    }

    return (
        <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={Math.ceil(totalCount / perPage)}
                marginPagesDisplayed={0}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'active'}
                forcePage={(currentPage ?? 1) - 1} 
                // forcePage={currentPage - 1}
            />
    )
}